/**
 * Entity helpers for training: exercise library, templates, scheduled reminders, and chat users.
 * Uses the same API client as client.js.
 */
import { apiRequest } from './client';

export const ChatUser = {
  get(userCode, fields) {
    const query = fields ? `?fields=${encodeURIComponent(fields)}` : '';
    return apiRequest(`/chat-users/${userCode}${query}`);
  }
};

export const ExerciseLibrary = {
  getAll(params = {}) {
    const q = new URLSearchParams();
    if (params.limit) q.set('limit', params.limit);
    if (params.category) q.set('category', params.category);
    if (params.search) q.set('search', params.search);
    const query = q.toString() ? `?${q.toString()}` : '';
    return apiRequest(`/exercise-library${query}`);
  },
  create(data) {
    return apiRequest(`/exercise-library`, {
      method: 'POST',
      body: data
    });
  }
};

export const TrainingPlanTemplates = {
  getOwn() {
    return apiRequest('/training-plan-templates');
  },
  getPublic() {
    return apiRequest('/training-plan-templates/public');
  },
  create(data) {
    return apiRequest('/training-plan-templates', {
      method: 'POST',
      body: data
    });
  },
  update(id, updates) {
    return apiRequest(`/training-plan-templates/${id}`, {
      method: 'PATCH', // or PUT depending on your backend
      body: updates
    });
  },
  delete(id) {
    return apiRequest(`/training-plan-templates/${id}`, {
      method: 'DELETE'
    });
  }
};

export const ScheduledReminders = {
  getPending() {
    return apiRequest('/training-reminders/pending');
  },
  create(data) {
    return apiRequest('/scheduled-reminders', {
      method: 'POST',
      body: data
    });
  }
};